var cssVariableRenderer = function cssVariableRenderer(element, name) {
  return function (latest) {
    return element.style.setProperty(name, latest);
  };
};

var styleRenderer = function styleRenderer(element, name) {
  return function (latest) {
    return element.style[name] = latest;
  };
};

export { cssVariableRenderer, styleRenderer };